<dui-badge [color]="statusColor" [isSolid]="isSolid">
    <ng-content></ng-content>
</dui-badge>
